import React, { Component } from "react";
import axios from "axios";
import { Grid, Row, Col } from "react-bootstrap";
import LoadingSpinner from "../components/Input/LoadingSpinner";
import SweetAlert from "react-bootstrap-sweetalert";
import HmacSHA256 from "crypto-js/hmac-sha256";

class PranoCante extends Component {
  state = {
    NrCante: "",
    AgjensiaBurim: "",
    PerdoruesId: "",
    IdProcesori: "",
    loading: false,
    alert: null,
    username: window.UserP.username,
  };

  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };

  hideAlert() {
   
    this.setState({
      alert: null,
    });
  }

  showErrors() {
    const getAlert = () => (
      <SweetAlert
        warning
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
  
  }

  showResponse() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Mesazh"
        closeOnClickOutside={false}
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        showCancel
      >
        {this.state.error1}
      </SweetAlert>
    );

    this.setState({
      alert: getAlert(),
    });
    
  }

  handleClick = (e) => {
    this.setState({ loading: true }, () => {
      const req = {
        NrCante: this.state.NrCante,
        AgjensiaBurim: window.UserP.agencyId,
        PerdoruesId: window.UserP.PerdoruesID,
        Token: HmacSHA256(
          Math.round(new Date().getTime() / 1000).toString(),
          window.UserP.key
        ).toString(),
      username: this.state.username,
      };
     
      axios
        .post(window.UserP.url + "POD/PranoCante", req)
        .then((response) => {
          const searchresults = response.data;
          if (searchresults.Result === true) {
            this.setState({
              loading: false,
              error1: searchresults.ResultMessage,
            });
            this.showResponse();
           
          } else {
            this.setState({
              loading: false,
              error1: searchresults.ResultMessage,
            });

            
            this.showErrors();
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            error1: "Ju lutem kontaktoni departamentin e IT!",
          });
          this.showErrors();
        });
    });
  };

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.state.loading ? (
              <LoadingSpinner />
            ) : (
              <div className="Form">
                <div className="card card-body bg-light col-md-6 mt-4">
                  <label className="">Nr. Cante</label>
                  <input
                    id="NrCante"
                    name="NrCante"
                    value={this.state.NrCante}
                    className="form-control "
                    type="text"
                    onChange={(e) => this.handleInputChange(e, "NrCante")}
                  />
                </div>
                <button
                  className="btn btn-primary "
                  onClick={() => this.handleClick()}
                >
                  <span data-notify="icon" className="pe-7s-diskette" />
                  &nbsp; Ruaj
                </button>
                <button className="btn btn-primary ml-4 ">
                  <span data-notify="icon" className="pe-7s-trash" />
                  &nbsp; Pastro
                </button>
                {this.state.alert}
                <div className="row"><p> </p></div>
              </div>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default PranoCante;
